export default __webpack_public_path__ + "static/eTHOsgPX-184899b54ea072765244d00a62494a1b.svg";